package com.karyadina.di

import com.karyadina.service.PurchaseHandler
import com.karyadina.service.SubscriptionService
import com.karyadina.service.StubPurchaseHandler
import io.ktor.client.HttpClient

/**
 * Web/JS - Return stub implementation
 */
actual fun providePurchaseHandler(
    subscriptionService: SubscriptionService,
    httpClient: HttpClient
): PurchaseHandler {
    return StubPurchaseHandler()
}